// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notion {
  font-size: 16px;
  line-height: 1.5;
  color: rgb(55, 53, 47);
  caret-color: rgb(55, 53, 47);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica,
    "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji", "Segoe UI Symbol";
}

.notion > *,
.notion-page > *,
.notion-column > * {
  padding: 3px 0px;
}

.notion * {
  box-sizing: border-box;
  margin-block-start: 0px;
  margin-block-end: 0px;
}

.notion-red {
  color: rgb(224, 62, 62);
}
.notion-pink {
  color: rgb(173, 26, 114);
}
.notion-blue {
  color: rgb(11, 110, 153);
}
.notion-purple {
  color: rgb(105, 64, 165);
}
.notion-teal {
  color: rgb(15, 123, 108);
}
.notion-yellow {
  color: rgb(223, 171, 1);
}
.notion-orange {
  color: rgb(217, 115, 13);
}
.notion-brown {
  color: rgb(100, 71, 58);
}
.notion-gray {
  color: rgb(155, 154, 151);
}
.notion-red_background {
  background-color: rgb(251, 228, 228);
}
.notion-pink_background {
  background-color: rgb(244, 223, 235);
}
.notion-blue_background {
  background-color: rgb(221, 235, 241);
}
.notion-purple_background {
  background-color: rgb(234, 228, 242);
}
.notion-teal_background {
  background-color: rgb(221, 237, 234);
}
.notion-yellow_background {
  background-color: rgb(251, 243, 219);
}
.notion-orange_background {
  background-color: rgb(250, 235, 221);
}
.notion-brown_background {
  background-color: rgb(233, 229, 227);
}
.notion-gray_background {
  background-color: rgb(235, 236, 237);
}
.notion-red_background_co {
  background-color: rgb(251, 228, 228, 0.3);
}
.notion-pink_background_co {
  background-color: rgb(244, 223, 235, 0.3);
}
.notion-blue_background_co {
  background-color: rgb(221, 235, 241, 0.3);
}
.notion-purple_background_co {
  background-color: rgb(234, 228, 242, 0.3);
}
.notion-teal_background_co {
  background-color: rgb(221, 237, 234, 0.3);
}
.notion-yellow_background_co {
  background-color: rgb(251, 243, 219, 0.3);
}
.notion-orange_background_co {
  background-color: rgb(250, 235, 221, 0.3);
}
.notion-brown_background_co {
  background-color: rgb(233, 229, 227, 0.3);
}
.notion-gray_background_co {
  background-color: rgb(235, 236, 237, 0.3);
}

.notion b {
  font-weight: 600;
}

.notion-title {
  font-size: 2.5em;
  font-weight: 700;
  margin-top: 0.75em;
  margin-bottom: 0.25em;
}

.notion-h1,
.notion-h2,
.notion-h3 {
  font-weight: 600;
  line-height: 1.3;
  padding: 3px 2px;
}

.notion-h1 {
  font-size: 1.875em;
  margin-top: 1.4em;
}
.notion-h1:first-child {
  margin-top: 0;
}
.notion-h2 {
  font-size: 1.5em;
  margin-top: 1.1em;
}
.notion-h3 {
  font-size: 1.25em;
  margin-top: 1em;
}
.notion-emoji {
  font-family: "Apple Color Emoji", Arial, sans-serif, "Segoe UI Emoji",
    "Segoe UI Symbol";
}
.notion-page-cover {
  display: block;
  object-fit: cover;
  width: 100%;
  height: 30vh;
  min-height: 30vh;
  padding: 0;
}

.notion-page {
  padding: 0;
  margin: 0 auto;
  max-width: 708px;
  width: 100%;
}

@media only screen and (max-width: 730px) {
  .notion-page {
    padding: 0 2vw;
  }
}

.notion-page-offset {
  margin-top: 96px;
}

span.notion-page-icon-cover {
  height: 78px;
  width: 78px;
  font-size: 78px;
  display: inline-block;
  line-height: 1.1;
  margin-left: 0px;
}

span.notion-page-icon-offset {
  margin-top: -42px;
}

img.notion-page-icon-cover {
  border-radius: 3px;
  width: 124px;
  height: 124px;
  margin: 8px;
}

img.notion-page-icon-offset {
  margin-top: -80px;
}

.notion-full-width {
  padding: 0 40px;
  max-width: 100%;
}

.notion-small-text {
  font-size: 14px;
}
.notion-quote {
  white-space: pre-wrap;
  word-break: break-word;
  border-left: 3px solid currentcolor;
  padding: 0.2em 0.9em;
  margin: 0;
  font-size: 1.2em;
}
.notion-hr {
  margin: 6px 0px;
  padding: 0;
  border-top-width: 1px;
  border-bottom-width: 0;
  border-color: rgba(55, 53, 47, 0.09);
}
.notion-link {
  color: inherit;
  word-break: break-word;
  text-decoration: underline;
  text-decoration-color: inherit;
}
.notion-blank {
  min-height: 1rem;
  padding: 3px 2px;
  margin-top: 1px;
  margin-bottom: 1px;
}
.notion-page-link {
  display: flex;
  color: rgb(55, 53, 47);
  text-decoration: none;
  height: 30px;
  margin: 1px 0px;
  transition: background 120ms ease-in 0s;
}
.notion-page-link:hover {
  background: rgba(55, 53, 47, 0.08);
}

.notion-page-icon {
  line-height: 1.4;
  margin-right: 4px;
  margin-left: 2px;
}
img.notion-page-icon {
  display: block;
  object-fit: cover;
  border-radius: 3px;
  width: 20px;
  height: 20px;
}

.notion-icon {
  display: block;
  width: 18px;
  height: 18px;
  color: rgba(55, 53, 47, 0.4);
}

.notion-page-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  line-height: 1.3;
  border-bottom: 1px solid rgba(55, 53, 47, 0.16);
  margin: 1px 0px;
}

.notion-inline-code {
  color: #eb5757;
  padding: 0.2em 0.4em;
  background: rgba(135, 131, 120, 0.15);
  border-radius: 3px;
  font-size: 85%;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier,
    monospace;
}

.notion-list {
  margin: 0;
  margin-block-start: 0.6em;
  margin-block-end: 0.6em;
}

.notion-list-disc {
  list-style-type: disc;
  padding-inline-start: 1.6em;
  margin-top: 0px;
  margin-bottom: 0px;
}
.notion-list-numbered {
  list-style-type: decimal;
  padding-inline-start: 1.6em;
  margin-top: 0px;
  margin-bottom: 0px;
}

.notion-list-disc li {
  padding-left: 0.1em;
}

.notion-list-numbered li {
  padding-left: 0.2em;
}

.notion-list li {
  padding: 4px 0px;
  white-space: pre-wrap;
}

.notion-list > .notion-text {
  margin-left: -1.6em;
  padding-left: 0px;
}

.notion-asset-wrapper {
  margin: 0.5rem auto 0.5rem;
  max-width: 100%;
}

.notion-asset-wrapper > img {
  max-width: 100%;
}

.notion-asset-wrapper iframe {
  border: none;
}

.notion-text {
  white-space: pre-wrap;
  caret-color: rgb(55, 53, 47);
  padding: 3px 2px;
}
.notion-block {
  padding: 3px 2px;
}

.notion .notion-code {
  font-size: 85%;
}

.notion-code {
  padding: 30px 16px 30px 20px;
  margin: 4px 0;
  border-radius: 3px;
  tab-size: 2;
  display: block;
  box-sizing: border-box;
  overflow-x: scroll;
  background: rgb(247, 246, 243);
  font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, Courier,
    monospace;
}

.notion-column {
  padding-top: 12px;
  padding-bottom: 12px;
}

.notion-column > *:first-child {
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
}

.notion-column > *:last-child {
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 0;
}

.notion-row {
  display: flex;
  overflow: hidden;
}

.notion-bookmark {
  margin: 4px 0;
  width: 100%;
  box-sizing: border-box;
  text-decoration: none;
  border: 1px solid rgba(55, 53, 47, 0.16);
  border-radius: 3px;
  display: flex;
  overflow: hidden;
  user-select: none;
}

.notion-bookmark > div:first-child {
  flex: 4 1 180px;
  padding: 12px 14px 14px;
  overflow: hidden;
  text-align: left;
  color: rgb(55, 53, 47);
}

.notion-bookmark-title {
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-height: 24px;
  margin-bottom: 2px;
}

.notion-bookmark-description {
  font-size: 12px;
  line-height: 16px;
  opacity: 0.6;
  height: 32px;
  overflow: hidden;
}

.notion-bookmark-link {
  display: flex;
  margin-top: 6px;
}

.notion-bookmark-link > img {
  width: 16px;
  height: 16px;
  min-width: 16px;
  margin-right: 6px;
}

.notion-bookmark-link > div {
  font-size: 12px;
  line-height: 16px;
  color: rgb(55, 53, 47);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notion-bookmark-image {
  flex: 1 1 180px;
  position: relative;
}

.notion-bookmark-image img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  position: absolute;
}

.notion-column .notion-bookmark-image {
  display: none;
}

@media (max-width: 640px) {
  .notion-bookmark-image {
    display: none;
  }

  .notion-row {
    flex-direction: column;
  }

  .notion-row > *,
  .notion-column > * {
    width: 100% !important;
  }
}

.notion-spacer:last-child {
  display: none;
}

.notion-image-inset {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 1px;
}

.notion-image-caption {
  padding: 6px 0px;
  white-space: pre-wrap;
  word-break: break-word;
  caret-color: rgb(55, 53, 47);
  font-size: 14px;
  line-height: 1.4;
  color: rgba(55, 53, 47, 0.6);
}

.notion-callout {
  padding: 16px 16px 16px 12px;
  display: inline-flex;
  width: 100%;
  border-radius: 3px;
  border-width: 1px;
  align-items: center;
  box-sizing: border-box;
  margin: 4px 0;
}
.notion-callout-text {
  margin-left: 8px;
  white-space: pre-line;
}

.notion-toggle {
  padding: 3px 2px;
}
.notion-toggle > summary {
  cursor: pointer;
  outline: none;
}
.notion-toggle > div {
  margin-left: 1.1em;
}

.notion-table,
.notion-th,
.notion-td {
  border: 1px solid rgba(55, 53, 47, 0.09);
  border-collapse: collapse;
}

.notion-table {
  width: 100%;
  border-left: none;
  border-right: none;
  border-spacing: 0px;
  white-space: nowrap;
}

.notion-th,
.notion-td {
  font-weight: normal;
  padding: 0.25em 0.5em;
  line-height: 1.5;
  min-height: 1.5em;
  text-align: left;
  font-size: 14px;
}

.notion-td.notion-bold {
  font-weight: 500;
}

.notion-th {
  color: rgba(55, 53, 47, 0.6);
  font-size: 14px;
}

.notion-td:first-child,
.notion-th:first-child {
  border-left: 0;
}

.notion-td:last-child,
.notion-th:last-child {
  border-right: 0;
}

.notion-gallery {
  display: grid;
  position: relative;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  grid-auto-rows: 1fr;
  gap: 16px;
  border-top: 1px solid rgba(55, 53, 47, 0.16);
  padding-top: 16px;
  padding-bottom: 4px;
}
.notion-gallery-card {
  display: block;
  color: inherit;
  text-decoration: none;
  box-shadow: rgba(15, 15, 15, 0.1) 0px 0px 0px 1px,
    rgba(15, 15, 15, 0.1) 0px 2px 4px;
  border-radius: 3px;
  background: white;
  overflow: hidden;
  transition: background 100ms ease-out 0s;
  position: static;
  height: 100%;
}

.notion-gallery-content {
  padding: 8px 10px 6px;
  font-size: 12px;
  white-space: nowrap;
}

.notion-gallery-data.is-first {
  white-space: nowrap;
  word-break: break-word;
  caret-color: rgb(55, 53, 47);
  font-size: 14px;
  line-height: 1.5;
  min-height: 21px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notion-page-header {
  position: sticky;
  top: 0;
  width: 100%;
  max-width: 100vw;
  height: 45px;
  min-height: 45px;
  display: flex;
  background: #fff;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  text-size-adjust: 100%;
  line-height: 1.5;
  line-height: 1.2;
  font-size: 14px;
}

.notion-nav-breadcrumbs {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  flex-grow: 0;
  min-width: 0;
  margin-right: 8px;
}

.notion-nav-breadcrumb {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  color: rgb(55, 53, 47);
  text-decoration: none;
  margin: 1px 0px;
  padding: 4px 6px;
  border-radius: 3px;
  transition: background 120ms ease-in 0s;
  user-select: none;
  background: transparent;
  cursor: pointer;
}

img.notion-nav-icon {
  width: 18px !important;
  height: 18px !important;
}

.notion-nav-icon {
  font-size: 18px;
  margin-right: 6px;
  line-height: 1.1;
  color: #000;
}

.notion-nav-breadcrumb:not(.notion-nav-breadcrumb-active):hover {
  background: rgba(55, 53, 47, 0.08);
}

.notion-nav-breadcrumb:not(.notion-nav-breadcrumb-active):active {
  background: rgba(55, 53, 47, 0.16);
}

.notion-nav-breadcrumb.notion-nav-breadcrumb-active {
  cursor: default;
}

.notion-nav-spacer {
  margin: 0 2px;
  color: rgba(55, 53, 47, 0.4);
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-notion/src/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B;+EAC6E;AAC/E;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE;qBACmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mCAAmC;EACnC,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;EACd;aACW;AACb;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B;aACW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4DAA4D;EAC5D,mBAAmB;EACnB,SAAS;EACT,4CAA4C;EAC5C,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB;qCACmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;;EAEnB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B","sourcesContent":[".notion {\n  font-size: 16px;\n  line-height: 1.5;\n  color: rgb(55, 53, 47);\n  caret-color: rgb(55, 53, 47);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica,\n    \"Apple Color Emoji\", Arial, sans-serif, \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n}\n\n.notion > *,\n.notion-page > *,\n.notion-column > * {\n  padding: 3px 0px;\n}\n\n.notion * {\n  box-sizing: border-box;\n  margin-block-start: 0px;\n  margin-block-end: 0px;\n}\n\n.notion-red {\n  color: rgb(224, 62, 62);\n}\n.notion-pink {\n  color: rgb(173, 26, 114);\n}\n.notion-blue {\n  color: rgb(11, 110, 153);\n}\n.notion-purple {\n  color: rgb(105, 64, 165);\n}\n.notion-teal {\n  color: rgb(15, 123, 108);\n}\n.notion-yellow {\n  color: rgb(223, 171, 1);\n}\n.notion-orange {\n  color: rgb(217, 115, 13);\n}\n.notion-brown {\n  color: rgb(100, 71, 58);\n}\n.notion-gray {\n  color: rgb(155, 154, 151);\n}\n.notion-red_background {\n  background-color: rgb(251, 228, 228);\n}\n.notion-pink_background {\n  background-color: rgb(244, 223, 235);\n}\n.notion-blue_background {\n  background-color: rgb(221, 235, 241);\n}\n.notion-purple_background {\n  background-color: rgb(234, 228, 242);\n}\n.notion-teal_background {\n  background-color: rgb(221, 237, 234);\n}\n.notion-yellow_background {\n  background-color: rgb(251, 243, 219);\n}\n.notion-orange_background {\n  background-color: rgb(250, 235, 221);\n}\n.notion-brown_background {\n  background-color: rgb(233, 229, 227);\n}\n.notion-gray_background {\n  background-color: rgb(235, 236, 237);\n}\n.notion-red_background_co {\n  background-color: rgb(251, 228, 228, 0.3);\n}\n.notion-pink_background_co {\n  background-color: rgb(244, 223, 235, 0.3);\n}\n.notion-blue_background_co {\n  background-color: rgb(221, 235, 241, 0.3);\n}\n.notion-purple_background_co {\n  background-color: rgb(234, 228, 242, 0.3);\n}\n.notion-teal_background_co {\n  background-color: rgb(221, 237, 234, 0.3);\n}\n.notion-yellow_background_co {\n  background-color: rgb(251, 243, 219, 0.3);\n}\n.notion-orange_background_co {\n  background-color: rgb(250, 235, 221, 0.3);\n}\n.notion-brown_background_co {\n  background-color: rgb(233, 229, 227, 0.3);\n}\n.notion-gray_background_co {\n  background-color: rgb(235, 236, 237, 0.3);\n}\n\n.notion b {\n  font-weight: 600;\n}\n\n.notion-title {\n  font-size: 2.5em;\n  font-weight: 700;\n  margin-top: 0.75em;\n  margin-bottom: 0.25em;\n}\n\n.notion-h1,\n.notion-h2,\n.notion-h3 {\n  font-weight: 600;\n  line-height: 1.3;\n  padding: 3px 2px;\n}\n\n.notion-h1 {\n  font-size: 1.875em;\n  margin-top: 1.4em;\n}\n.notion-h1:first-child {\n  margin-top: 0;\n}\n.notion-h2 {\n  font-size: 1.5em;\n  margin-top: 1.1em;\n}\n.notion-h3 {\n  font-size: 1.25em;\n  margin-top: 1em;\n}\n.notion-emoji {\n  font-family: \"Apple Color Emoji\", Arial, sans-serif, \"Segoe UI Emoji\",\n    \"Segoe UI Symbol\";\n}\n.notion-page-cover {\n  display: block;\n  object-fit: cover;\n  width: 100%;\n  height: 30vh;\n  min-height: 30vh;\n  padding: 0;\n}\n\n.notion-page {\n  padding: 0;\n  margin: 0 auto;\n  max-width: 708px;\n  width: 100%;\n}\n\n@media only screen and (max-width: 730px) {\n  .notion-page {\n    padding: 0 2vw;\n  }\n}\n\n.notion-page-offset {\n  margin-top: 96px;\n}\n\nspan.notion-page-icon-cover {\n  height: 78px;\n  width: 78px;\n  font-size: 78px;\n  display: inline-block;\n  line-height: 1.1;\n  margin-left: 0px;\n}\n\nspan.notion-page-icon-offset {\n  margin-top: -42px;\n}\n\nimg.notion-page-icon-cover {\n  border-radius: 3px;\n  width: 124px;\n  height: 124px;\n  margin: 8px;\n}\n\nimg.notion-page-icon-offset {\n  margin-top: -80px;\n}\n\n.notion-full-width {\n  padding: 0 40px;\n  max-width: 100%;\n}\n\n.notion-small-text {\n  font-size: 14px;\n}\n.notion-quote {\n  white-space: pre-wrap;\n  word-break: break-word;\n  border-left: 3px solid currentcolor;\n  padding: 0.2em 0.9em;\n  margin: 0;\n  font-size: 1.2em;\n}\n.notion-hr {\n  margin: 6px 0px;\n  padding: 0;\n  border-top-width: 1px;\n  border-bottom-width: 0;\n  border-color: rgba(55, 53, 47, 0.09);\n}\n.notion-link {\n  color: inherit;\n  word-break: break-word;\n  text-decoration: underline;\n  text-decoration-color: inherit;\n}\n.notion-blank {\n  min-height: 1rem;\n  padding: 3px 2px;\n  margin-top: 1px;\n  margin-bottom: 1px;\n}\n.notion-page-link {\n  display: flex;\n  color: rgb(55, 53, 47);\n  text-decoration: none;\n  height: 30px;\n  margin: 1px 0px;\n  transition: background 120ms ease-in 0s;\n}\n.notion-page-link:hover {\n  background: rgba(55, 53, 47, 0.08);\n}\n\n.notion-page-icon {\n  line-height: 1.4;\n  margin-right: 4px;\n  margin-left: 2px;\n}\nimg.notion-page-icon {\n  display: block;\n  object-fit: cover;\n  border-radius: 3px;\n  width: 20px;\n  height: 20px;\n}\n\n.notion-icon {\n  display: block;\n  width: 18px;\n  height: 18px;\n  color: rgba(55, 53, 47, 0.4);\n}\n\n.notion-page-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n  line-height: 1.3;\n  border-bottom: 1px solid rgba(55, 53, 47, 0.16);\n  margin: 1px 0px;\n}\n\n.notion-inline-code {\n  color: #eb5757;\n  padding: 0.2em 0.4em;\n  background: rgba(135, 131, 120, 0.15);\n  border-radius: 3px;\n  font-size: 85%;\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, Courier,\n    monospace;\n}\n\n.notion-list {\n  margin: 0;\n  margin-block-start: 0.6em;\n  margin-block-end: 0.6em;\n}\n\n.notion-list-disc {\n  list-style-type: disc;\n  padding-inline-start: 1.6em;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n.notion-list-numbered {\n  list-style-type: decimal;\n  padding-inline-start: 1.6em;\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\n.notion-list-disc li {\n  padding-left: 0.1em;\n}\n\n.notion-list-numbered li {\n  padding-left: 0.2em;\n}\n\n.notion-list li {\n  padding: 4px 0px;\n  white-space: pre-wrap;\n}\n\n.notion-list > .notion-text {\n  margin-left: -1.6em;\n  padding-left: 0px;\n}\n\n.notion-asset-wrapper {\n  margin: 0.5rem auto 0.5rem;\n  max-width: 100%;\n}\n\n.notion-asset-wrapper > img {\n  max-width: 100%;\n}\n\n.notion-asset-wrapper iframe {\n  border: none;\n}\n\n.notion-text {\n  white-space: pre-wrap;\n  caret-color: rgb(55, 53, 47);\n  padding: 3px 2px;\n}\n.notion-block {\n  padding: 3px 2px;\n}\n\n.notion .notion-code {\n  font-size: 85%;\n}\n\n.notion-code {\n  padding: 30px 16px 30px 20px;\n  margin: 4px 0;\n  border-radius: 3px;\n  tab-size: 2;\n  display: block;\n  box-sizing: border-box;\n  overflow-x: scroll;\n  background: rgb(247, 246, 243);\n  font-family: SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, Courier,\n    monospace;\n}\n\n.notion-column {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.notion-column > *:first-child {\n  margin-top: 0;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.notion-column > *:last-child {\n  margin-left: 0;\n  margin-right: 0;\n  margin-bottom: 0;\n}\n\n.notion-row {\n  display: flex;\n  overflow: hidden;\n}\n\n.notion-bookmark {\n  margin: 4px 0;\n  width: 100%;\n  box-sizing: border-box;\n  text-decoration: none;\n  border: 1px solid rgba(55, 53, 47, 0.16);\n  border-radius: 3px;\n  display: flex;\n  overflow: hidden;\n  user-select: none;\n}\n\n.notion-bookmark > div:first-child {\n  flex: 4 1 180px;\n  padding: 12px 14px 14px;\n  overflow: hidden;\n  text-align: left;\n  color: rgb(55, 53, 47);\n}\n\n.notion-bookmark-title {\n  font-size: 14px;\n  line-height: 20px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-height: 24px;\n  margin-bottom: 2px;\n}\n\n.notion-bookmark-description {\n  font-size: 12px;\n  line-height: 16px;\n  opacity: 0.6;\n  height: 32px;\n  overflow: hidden;\n}\n\n.notion-bookmark-link {\n  display: flex;\n  margin-top: 6px;\n}\n\n.notion-bookmark-link > img {\n  width: 16px;\n  height: 16px;\n  min-width: 16px;\n  margin-right: 6px;\n}\n\n.notion-bookmark-link > div {\n  font-size: 12px;\n  line-height: 16px;\n  color: rgb(55, 53, 47);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.notion-bookmark-image {\n  flex: 1 1 180px;\n  position: relative;\n}\n\n.notion-bookmark-image img {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n}\n\n.notion-column .notion-bookmark-image {\n  display: none;\n}\n\n@media (max-width: 640px) {\n  .notion-bookmark-image {\n    display: none;\n  }\n\n  .notion-row {\n    flex-direction: column;\n  }\n\n  .notion-row > *,\n  .notion-column > * {\n    width: 100% !important;\n  }\n}\n\n.notion-spacer:last-child {\n  display: none;\n}\n\n.notion-image-inset {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 1px;\n}\n\n.notion-image-caption {\n  padding: 6px 0px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  caret-color: rgb(55, 53, 47);\n  font-size: 14px;\n  line-height: 1.4;\n  color: rgba(55, 53, 47, 0.6);\n}\n\n.notion-callout {\n  padding: 16px 16px 16px 12px;\n  display: inline-flex;\n  width: 100%;\n  border-radius: 3px;\n  border-width: 1px;\n  align-items: center;\n  box-sizing: border-box;\n  margin: 4px 0;\n}\n.notion-callout-text {\n  margin-left: 8px;\n  white-space: pre-line;\n}\n\n.notion-toggle {\n  padding: 3px 2px;\n}\n.notion-toggle > summary {\n  cursor: pointer;\n  outline: none;\n}\n.notion-toggle > div {\n  margin-left: 1.1em;\n}\n\n.notion-table,\n.notion-th,\n.notion-td {\n  border: 1px solid rgba(55, 53, 47, 0.09);\n  border-collapse: collapse;\n}\n\n.notion-table {\n  width: 100%;\n  border-left: none;\n  border-right: none;\n  border-spacing: 0px;\n  white-space: nowrap;\n}\n\n.notion-th,\n.notion-td {\n  font-weight: normal;\n  padding: 0.25em 0.5em;\n  line-height: 1.5;\n  min-height: 1.5em;\n  text-align: left;\n  font-size: 14px;\n}\n\n.notion-td.notion-bold {\n  font-weight: 500;\n}\n\n.notion-th {\n  color: rgba(55, 53, 47, 0.6);\n  font-size: 14px;\n}\n\n.notion-td:first-child,\n.notion-th:first-child {\n  border-left: 0;\n}\n\n.notion-td:last-child,\n.notion-th:last-child {\n  border-right: 0;\n}\n\n.notion-gallery {\n  display: grid;\n  position: relative;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  grid-auto-rows: 1fr;\n  gap: 16px;\n  border-top: 1px solid rgba(55, 53, 47, 0.16);\n  padding-top: 16px;\n  padding-bottom: 4px;\n}\n.notion-gallery-card {\n  display: block;\n  color: inherit;\n  text-decoration: none;\n  box-shadow: rgba(15, 15, 15, 0.1) 0px 0px 0px 1px,\n    rgba(15, 15, 15, 0.1) 0px 2px 4px;\n  border-radius: 3px;\n  background: white;\n  overflow: hidden;\n  transition: background 100ms ease-out 0s;\n  position: static;\n  height: 100%;\n}\n\n.notion-gallery-content {\n  padding: 8px 10px 6px;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n.notion-gallery-data.is-first {\n  white-space: nowrap;\n  word-break: break-word;\n  caret-color: rgb(55, 53, 47);\n  font-size: 14px;\n  line-height: 1.5;\n  min-height: 21px;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.notion-page-header {\n  position: sticky;\n  top: 0;\n  width: 100%;\n  max-width: 100vw;\n  height: 45px;\n  min-height: 45px;\n  display: flex;\n  background: #fff;\n  flex-direction: row;\n  box-sizing: border-box;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 12px;\n  text-size-adjust: 100%;\n  line-height: 1.5;\n  line-height: 1.2;\n  font-size: 14px;\n}\n\n.notion-nav-breadcrumbs {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 100%;\n  flex-grow: 0;\n  min-width: 0;\n  margin-right: 8px;\n}\n\n.notion-nav-breadcrumb {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n\n  color: rgb(55, 53, 47);\n  text-decoration: none;\n  margin: 1px 0px;\n  padding: 4px 6px;\n  border-radius: 3px;\n  transition: background 120ms ease-in 0s;\n  user-select: none;\n  background: transparent;\n  cursor: pointer;\n}\n\nimg.notion-nav-icon {\n  width: 18px !important;\n  height: 18px !important;\n}\n\n.notion-nav-icon {\n  font-size: 18px;\n  margin-right: 6px;\n  line-height: 1.1;\n  color: #000;\n}\n\n.notion-nav-breadcrumb:not(.notion-nav-breadcrumb-active):hover {\n  background: rgba(55, 53, 47, 0.08);\n}\n\n.notion-nav-breadcrumb:not(.notion-nav-breadcrumb-active):active {\n  background: rgba(55, 53, 47, 0.16);\n}\n\n.notion-nav-breadcrumb.notion-nav-breadcrumb-active {\n  cursor: default;\n}\n\n.notion-nav-spacer {\n  margin: 0 2px;\n  color: rgba(55, 53, 47, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
